export const copyText = (text: string) => {
  try {
    navigator.clipboard.writeText(text);
  } catch {
    // navigator.clipboard() is not supported in iOS Safari 12.2-12.5
    // Apple currently supports the last two generations of the iPhone operating system: iOS 16 or 15. Because iPhones that could run iOS 13 and iOS 14 can run iOS 15, those versions of iOS are considered obsolete by Apple and aren't updated.
  }
};
